var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modul-PC"},[_vm._v("这里是PC端设计")])
}
var staticRenderFns = []

export { render, staticRenderFns }